var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"variant":_vm.variant}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.result_export.status)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }